import React from 'react';
import { range } from 'lodash';
import Img from '../../../../../components/Img/Img';
import TagPreviewItemHeader from '../TagPreviewItemHeader';
import './TagPreviewMainTabItem.scss';

const TagPreviewItemMainTabItem = (props) => {
  const { tagName, tagViewInfo, itemContentList } = props;

  return (
    <div className="tag-preview-main-tab-item">
      <TagPreviewItemHeader tagName={tagName} tagViewInfo={tagViewInfo} />

      <div className="tag-main-tab-item-img-list">
        <div className="tag-main-tab-item-img-1-area">
          <Img className="big" clickAble={false} src={itemContentList[0] ? itemContentList[0].url : null} />
        </div>
        <div className="tag-main-tab-item-img-2-area">
          {range(1, 3).map((index) => (
            <Img
              className="small"
              key={index}
              clickAble={false}
              src={itemContentList[index] ? itemContentList[index].url : null}
            />
          ))}
        </div>
        <div className="tag-main-tab-item-img-3-area">
          {range(3, 6).map((index) => (
            <Img
              className="small"
              key={index}
              clickAble={false}
              src={itemContentList[index] ? itemContentList[index].url : null}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TagPreviewItemMainTabItem;
